import { ReactNode } from 'react';
import Accordion from '@mui/material/Accordion';
import { default as AccordionDetails } from '@mui/material/AccordionDetails';
import { default as AccordionSummary } from '@mui/material/AccordionSummary';
import { Text } from 'components/Text';
import { Iconify } from 'modules/minimal-ui-theme';

interface Props {
  title: string;
  children: ReactNode;
}

export const AccordionSection = ({ title, children }: Props) => (
  <Accordion>
    <AccordionSummary
      expandIcon={<Iconify icon="eva:arrow-ios-downward-fill" />}
    >
      <Text
        variant="h5"
        width="100%"
        sx={{ mt: 1, textAlign: { xs: 'left', sm: 'center' } }}
      >
        {title}
      </Text>
    </AccordionSummary>
    <AccordionDetails
      sx={{
        p: 3,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      }}
    >
      {children}
    </AccordionDetails>
  </Accordion>
);
